import EmbedVideoPlayer from "./EmbedVideoPlayer";
export default EmbedVideoPlayer;
